import { render, staticRenderFns } from "./BaseFormGroup.vue?vue&type=template&id=6fb43039&"
import script from "./BaseFormGroup.vue?vue&type=script&lang=js&"
export * from "./BaseFormGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports